import { createLayerCanvas, drawPointsPath, toDataUrl } from './canvasUtils'
import { extractLandmarkFeatures } from './extractLandmarkFeatures'

export const buildFaceLayer = ({ landmarks, width, height, features = null }) => {
  if (!landmarks?.length) return null
  const featureMap = features || extractLandmarkFeatures({ landmarks, width, height })
  const polygon = featureMap?.face?.polygon || []
  if (!polygon.length) return null
  const { canvas, ctx } = createLayerCanvas(width, height)
  drawPointsPath(ctx, polygon, {
    close: true,
    fill: 'rgba(103, 232, 249, 0.46)'
  })
  return toDataUrl(canvas)
}
